import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-home-hero]',
  imports: [NgOptimizedImage, MatButtonModule, ShowleftDirective, RouterModule],
  templateUrl: './home-hero.html',
  styleUrl: './home-hero.scss',
})
export class HomeHero {

  get newArrivalsNo(): string {
    return environment.collection.new_arrivals;
  }

  get bestSellerNo(): string {
    return environment.collection.best_sellers;
  }
}
